import { PublicPartnerCategoryResponse } from '@/features/partners/types/partners.types';
import { cn } from '@/lib/utils';

interface CategoryTabsProps {
  categories: PublicPartnerCategoryResponse[];
  selectedCategory: number | null;
  onSelectCategory: (categoryId: number | null) => void;
}

export function CategoryTabs({
  categories,
  selectedCategory,
  onSelectCategory,
}: CategoryTabsProps) {
  return (
    <div className="mb-8" role="tablist" aria-label="Filter partners by category">
      <div className="flex flex-wrap gap-2 justify-center">
        <button
          role="tab"
          aria-selected={selectedCategory === null}
          onClick={() => onSelectCategory(null)}
          className={cn(
            'rounded-full px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            selectedCategory === null
              ? 'bg-primary text-primary-foreground'
              : 'bg-secondary text-secondary-foreground hover:bg-secondary/80'
          )}
        >
          All Partners
        </button>

        {categories.map((category) => (
          <button
            key={category.id}
            role="tab"
            aria-selected={selectedCategory === category.id}
            onClick={() => onSelectCategory(category.id)}
            className={cn(
              'rounded-full px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
              selectedCategory === category.id
                ? 'bg-primary text-primary-foreground'
                : 'bg-secondary text-secondary-foreground hover:bg-secondary/80'
            )}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default CategoryTabs;
